import { useEffect, useState } from 'react';

import {
  Certificate,
  createDetachedSignature,
  createAttachedSignature,
  getUserCertificates,
} from 'crypto-pro';

const getCertificates = (
  setCertificates: (certificates: Certificate[]) => void,
  onError: (message: string) => void
) => {
  getUserCertificates()
    .then((certificates) => {
      setCertificates(certificates);
    })
    .catch((error) => {
      onError(error.message);
      if (error.message === 'Ошибка при попытке доступа к хранилищу') {
        setTimeout(() => getCertificates(setCertificates, onError));
      }
    });
};

export const useCryptoCertificates = (
  selectedCertThumbprint: string | undefined,
  onError: (message: string) => void,
  isActive: boolean = true
) => {
  const [certificates, setCertificates] = useState<Certificate[]>([]);

  useEffect(() => {
    if (isActive) {
      getCertificates(setCertificates, onError);
    }
  }, [isActive]);

  const signEntity = async (hash: string, attached: boolean = false) => {
    try {
      const currentCert = certificates.find(
        (item) => item.thumbprint === selectedCertThumbprint
      );
      if (currentCert) {
        if (attached) {
          const attachedSignature = await createAttachedSignature(
            currentCert.thumbprint,
            hash
          );
          return {
            pdfSigned: attachedSignature,
            signed: hash,
          };
        } else {
          const detachedSignature = await createDetachedSignature(
            currentCert.thumbprint,
            hash
          );
          return {
            pdfSigned: detachedSignature,
            signed: hash,
          };
        }
      }
      return await {
        pdfSigned: undefined,
        signed: undefined,
      };
    } catch (error: any) {
      onError(error.message);
      return await {
        pdfSigned: undefined,
        signed: undefined,
      };
    }
  };

  return {
    certificates,
    signEntity,
  };
};
